import React from "react";

const RightTopArrowIcon = ({
  width = 10,
  height = 11,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 10 11"
    fill="none"
    className={className}
  >
    <path
      d="M9.59896 1.46477C9.5795 1.13397 9.29556 0.881578 8.96477 0.901037L3.57408 1.21814C3.24328 1.23759 2.99089 1.52153 3.01035 1.85233C3.02981 2.18313 3.31375 2.43552 3.64455 2.41606L8.43627 2.1342L8.71813 6.92592C8.73759 7.25671 9.02153 7.50911 9.35233 7.48965C9.68313 7.47019 9.93552 7.18625 9.91606 6.85545L9.59896 1.46477ZM1.44845 10.8986L9.44844 1.89862L8.55155 1.10138L0.551554 10.1014L1.44845 10.8986Z"
      fill="currentColor"
    />
  </svg>
);

export default RightTopArrowIcon;
